export default defineNuxtRouteMiddleware((to, from) => {
    to.path = decodeURIComponent(to.path);
});